import {makeStyles, Tooltip, Button, TextField, Box} from "@material-ui/core";
//import UtilService from "../../../../../helper/service";
import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getShareLink, updateUserAttributesAnalyze} from "../../../../../store/actions/creator/analysis";
import {BackDropAnalyzeLoading} from "../../../../atoms/commonLoadings";
import XLSXDownloadBtn from '../../../../atoms/creator/analyzeXlsxDownBtn';
import ImmersionModal from "../../../../atoms/modals/commonModal";
import Config from "../../../../../config/config";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import OverviewTabClipsPopout from "../../../../atoms/creator/overviewTabClipsPopout";
import { Feature } from 'flagged';

import CardHeader from '@material-ui/core/CardHeader';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '@material-ui/icons/Image';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarIcon from '@material-ui/icons/Star';
import ShareIcon from '@material-ui/icons/Share';
import AttachmentIcon from '@material-ui/icons/Attachment';

import LinearProgress from '@material-ui/core/LinearProgress';
import UtilService from "../../../../../helper/service";
import axios from 'axios';
import {
  getSessionParticipants,
  updateFullLoadedOverview,
} from '../../../../../store/actions/creator/creatorExperienceManager';
import {apiClient} from '../../../../../config/apiClient';
import {getStimulusAnalysis, updateSettings,} from '../../../../../store/actions/creator/analysis';
import {v4 as uuid_v4} from "uuid";
import {Auth, Storage} from "aws-amplify";
import VideocamIcon from '@material-ui/icons/Videocam';


const useStyles = makeStyles(() => ({
    bannerPanel: {
      height: 40,
      backgroundColor: '#1DB859',
      marginTop: 48,
      zIndex: 1,
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'roboto-regular',
      color: '#FFFFFF',
      fontSize: 14,
      '@media screen and (max-width: 800px)': {
        fontSize: 12
      }
    },
    clickBtn: {
      fontFamily: 'roboto-bold',
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    icon: {
      width: 12,
      height: 12,
      cursor: 'pointer',
      position: 'fixed',
      right: 15
    },
    descriptionDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    shareBtn: {
        width: 100,
        borderRadius: 6,
        background: '#017AEF',
        color: '#fff',
        textTransform: 'none',
        marginRight: 5,
        '&:hover': {
          background: '#0f9fef',
          color: '#fff',
        }
      },
      container: {
        margin: '17px 12px 32px -12px'
      },
      copyBtn: {
        margin: 22,
        marginLeft: 0
      },
      p1: {
        fontFamily: 'roboto-regular',
        fontSize: 15,
        color: '#555',
        lineHeight: 1.4
      },
      p2: {
        marginTop: 30,
        fontFamily: 'roboto-regular',
        fontSize: 13,
        color: '#555'
      },
      text: {
        fontFamily: 'roboto-medium',
        fontSize: 13,
        lineHeight: 1.6,
        color: '#555',
        marginTop: 25,
      },
      confirmBtn: {
        width: 300,
        height: 46,
        borderRadius: 8,
        marginTop: 30,
        textTransform: 'none'
      },
      headerPanel: {
        minHeight: 48,
        paddingTop: 3,
        width: '100%',
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #D9D9D9',
        display: 'flex',
        alignItems: 'center',
        position: 'fixed',
        zIndex: 1
      },
      videomodelCss: {
        marginRight: 40
      },
      videolabel: {
        "&$focusedLabel": {
          color: "#707070"
        },
        "&$erroredLabel": {
          color: "#707070"
        }
      },
      videofocusedLabel: {
        fontSize: 14,
        fontFamily: 'roboto-black',
      },
      videoerroredLabel: {},
      videounderline: {
        fontSize: 14,
        fontFamily: 'roboto-regular',
        color: '#8F99A3',
      },
      videonormal: {
        color: '#8F99A3',
        "&:before": {
          borderBottom: `1px solid rgba(0, 0, 0, 0.42)`
        },
        "&:after": {
          borderBottom: `1px solid rgba(0, 0, 0, 0.42)`
        }
      },
      videoerror: {
        color: '#f44336',
        "&:before": {
          borderBottom: `1px solid #f44336`
        },
        "&:after": {
          borderBottom: `1px solid #f44336`
        }
      },
      videolinkError: {
        fontFamily: 'roboto-regular',
        fontSize: 14,
        color: '#de4a39'
      },
      videobrowseBtn: {
        flex: 1,
        textTransform: "unset",
        backgroundColor: '#F0F0F0',
        color: '#697683'
      },
      videofileInput: {
        display: 'none'
      },
      videoanchor: {
        color: '#017AEF',
        textDecoration: 'none'
      },
      videosuccessLabel: {
        margin: "auto",
        textAlign: 'center',
        // marginTop: 70,
        fontFamily: 'roboto-regular',
      },
      videoprogress: {
        width: '100%',
        marginBottom: 30,
        marginTop: 50
      },
      videocalendarBtnLabel: {
        fontSize: 16,
        fontFamily: 'roboto-regular',
        textTransform: 'none'
      },
  }));
  
  interface IProps {
    onSaveBenchmark: () => void,
    onDownloadImage: () => void,
    backgroundColor: string,
    fontColor: string,
    isBenchmark: boolean,
    starColor: string,
    sessionCode?: any,
    session: any
  }
  
  const OverviewCardHeader = (props: IProps) => {
    const classes = useStyles();
    const { onSaveBenchmark, backgroundColor, fontColor, isBenchmark, starColor, onDownloadImage, session } = props;
    const dispatch = useDispatch();
    const [showShareModal, setShowShareModal] = useState(false);
    const [uuid, setUUID] = useState(null);
    const [loading, setLoading] = useState(false);
    const { sessionData, stimulusList, freeText } = useSelector((state: any) => state.creatorExperienceManager);
    const { cliped } = useSelector((state: any) => state.analysis);
    const apolloClient = useSelector((state: any) => state.apolloClient);
    const [copied, setCopied] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";


    const [showVideoModal, setShowVideoModal] = useState(false);
    const [isLink, setisLink] = useState(false);
    const [fileInput, setFileInput] = useState(null);
    const [videoUrl, setVideoUrl] = useState("");
    const [asyncFileName, setAsyncFileName] = useState("");
    const [asyncFile, setAsyncFile] = useState<any>(null);
    const [next, setNext] = useState(true);
    //const [videoWidth, setVideoWidth] = useState(355);
    //const [videoHeight, setVideoHeight] = useState(240);
    const [finishUploadVideoResult, setFinishUploadVideoResult] = useState('');
    const [uploadVideoProgress, setUploadVideoProgress] = useState(0);
    const [linkError, setLinkError] = useState(false);
    const [showSizeAlarm, setShowSizeAlarm] = useState(false);

    const onChangeVideoUrl = (event: any) => {
      const videoUrl = event.target.value;
      const baseUrl = UtilService.checkYoutubeVimeoURL(videoUrl) || !videoUrl;
      const cleandURL = videoUrl.replace('app=desktop&', '');
      if (baseUrl) {
        axios.get(`${baseUrl}${cleandURL}&format=json`)
          .then(() => setLinkError(false))
          .catch(() => setLinkError(true))
      } else {
        setLinkError(true);
      }
  
      if (UtilService.validateYouTubeUrl(videoUrl) || UtilService.validateVimeoUrl(videoUrl)) {
        setVideoUrl(videoUrl)
      } else {
        setVideoUrl("")
      }
    };
  
    useEffect(() => {
      if (isLink) {
        videoUrl ? setNext(false) : setNext(true)
      } else {
        asyncFileName ? setNext(false) : setNext(true)
      }
    }, [isLink, asyncFileName, videoUrl]);
  
    const onCloseAddVideo = () => {
      setShowVideoModal(false);
      setAsyncFileName("");
      setVideoUrl("");
      setAsyncFile(null);
      setFinishUploadVideoResult('');
    };
  
    const uploadVideo = async () => {
      setUploadVideoProgress(0);
      setLoading(true);
      const regExpStr = '(?!(^xn--|.+-s3alias$))^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$';
      const regExp = new RegExp(regExpStr);
      const streamType = UtilService.validateYouTubeUrl(videoUrl) ? 'YOUTUBE' : 'VIMEO';
      const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
      const fileType = UtilService.isValidAudio(asyncFileName) ? 'AUDIO' : 'VIDEO';
      const session_title = session?.session_title ? ((regExp.test(session.session_title) == true) ? session.session_title : 'Title not permited') : 'No Title';

      const payload = {
        file: asyncFile ? asyncFile : null,
        fileName: asyncFileName,
        streamType: isLink ? streamType : (session?.session_type === 'ASYNC' ? 'VDO' : 'IMS'),
        stimulusType: fileType,
        sessionCode: session?.session_code,
        sortOrder: "1",
        tenantId: loginUserData.customer_id,
        stimulusAlias: session_title,
        stimulusDescription: videoUrl ? videoUrl : ''
      };
      const res: any = await handleUpload(payload);
      console.log('res', res);
  
      if (res && res.key) {
        setFinishUploadVideoResult('You uploaded the video successfully.');
        setLoading(false);
        setUploadVideoProgress(0);
        dispatch(updateFullLoadedOverview(false));
        setTimeout(async () => {
          const request = {
            session_code: session?.session_code,
          };
          const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${session?.session_code}`);
          dispatch(getStimulusAnalysis(res.data && res.data[0]))
          dispatch(getSessionParticipants(apolloClient.client, request));
          dispatch(updateFullLoadedOverview(true));
          dispatch(updateSettings('videoBase64Img', null));
  
        }, 15000);
      } else {
        setUploadVideoProgress(0);
        setFinishUploadVideoResult('Failed')
      }
    };
  
    const handleUpload = async (payload: any) => {
      const {
        file,
        fileName,
        streamType
      } = payload;
  
      const fileId = uuid_v4();
      if (streamType === "YOUTUBE" || streamType === "VIMEO") {
        const fileKey = `uploads/${fileId}`;
        return await uploadToS3(fileId, fileKey, " ", payload);
      } else {
        const fileKey = `uploads/${fileId}-${fileName}`;
        return await uploadToS3(fileId, fileKey, file, payload);
      }
    };
  
    const uploadToS3 = async (fileId: any, fileKey: string, file: any, payload: any) => {
      const {
        sessionCode,
        sortOrder,
        tenantId,
        stimulusType,
        streamType,
        stimulusAlias,
        stimulusDescription
      } = payload;
      const currentUser = await Auth.currentUserInfo();
  
      return await Storage.put(fileKey, file, {
        progressCallback(progress: any) {
          setTimeout(() => {
            setUploadVideoProgress(progress.loaded / progress.total * 100)
          }, 500);
        },
        level: 'private',
        metadata: {
          FileId: fileId,
          SessionCode: sessionCode,
          SortOrder: sortOrder,
          TenantId: tenantId,
          StimulusType: stimulusType,
          StreamType: streamType,
          StimulusAlias: stimulusAlias,
          StimulusDescription: stimulusDescription,
          Email: currentUser.attributes.email,
          UserName: currentUser.username
        }
      });
    };

    const toggleUploadMethod = (isLink: boolean) => {
      setisLink(isLink)
    };

    const triggerInputFile = (fileInput: any) => {
      if (fileInput) {
        fileInput.click();
        setFinishUploadVideoResult('');
        setAsyncFileName('');
        setAsyncFile(null)
      }
    };

    const handleFileInput = (e: any) => {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        const fileName = file.name;
  
        // check updated file size and show alarm if size is bigger than 200 MB.
        const fileSize = file.size;
        const mFileSize = Number((fileSize / (1000 * 1000)).toFixed(2));
        if (mFileSize > 200) setShowSizeAlarm(true);
        else setShowSizeAlarm(false);
  
        const uniqueFileName = new Date().getTime() + '.' + fileName.split(".").pop();
        setAsyncFileName(uniqueFileName);
        setAsyncFile(file)
      }
    };




    useEffect(() => {
        if (copied) {
        setTimeout(() => {
            setCopied(false);
        }, 20000);
        }
    }, [copied]);

    const onToggleShareModal = () => {
        setShowShareModal(!showShareModal);
        setCopied(false);
        setConfirmed(false);
    };

    const onCallShareAPI = () => {
        setLoading(true);
    
        const request = !cliped ? {
          session_code: props.sessionCode 
        } : {
          session_code: props.sessionCode,
          clip_data: {...cliped, freeText }
        }
        dispatch(getShareLink(apolloClient.client, request, (res: any) => {
          setLoading(false);
          setUUID(res?.share?.data?.uuid);
          setShowShareModal(true);
          dispatch(updateUserAttributesAnalyze(apolloClient.client, {
            user_id: loginUserData.user_id,
            metrics_value: props.sessionCode,
            metrics_type: "EXPERIENCESHARE",
          }))
        }))
      };
    
      const onShowClipsModal = (e: any) => {
        (session && session['stimulusclips'].length > 0) && setAnchorEl(e.currentTarget);
      };
    
      const showShareBtn = useCallback(() => {
        return (
          (!cliped && sessionData && (sessionData['session']['session_status'] === 'COMPLETED'))
          || (cliped)
        );
      }, [sessionData, cliped]);


    const onUpdate = () => {
        onSaveBenchmark();
      };

    const download = () => {
        onDownloadImage();
    };  

    if (classes && anchorEl) {

    }

    return (
        <>

        <CardHeader title="Results Overview" style={{background: backgroundColor, color: fontColor}} action={
            <ButtonGroup color="primary" id={'toolsgroup'} aria-label="primary button group">

            {(session && session['stimulusclips'].length > 0) && (

            <Tooltip title={`Review the ${ session['stimulusclips'].length } ${session['stimulusclips'].length > 1 ? 'Clips' : 'Clip'} of this experience`}>   
                <IconButton aria-label="settings" onClick={onShowClipsModal}><AttachmentIcon style={{color: fontColor}} /></IconButton>
            </Tooltip>
            )}

              <Tooltip title="Add/remove this experience from your benchmark">
                <IconButton aria-label="settings" onClick={onUpdate}>{ isBenchmark ? <StarIcon style={{color: starColor}} />  : <StarBorderIcon style={{color: fontColor}} /> } </IconButton>
              </Tooltip>

              {
                (!cliped && session?.session_status === 'COMPLETED' && session?.session_type === 'MODERATED') &&
                <Tooltip title="Upload or attach a video to this experience">
                  <IconButton aria-label="settings" onClick={() => setShowVideoModal(true)}><VideocamIcon style={{color: fontColor}} /></IconButton>
                </Tooltip>
              }



              {showShareBtn() && (
                <Tooltip title="Share a link to these results">
                    <IconButton aria-label="settings" id="shareButton" onClick={() => { onToggleShareModal() }}><ShareIcon style={{color: fontColor}} /></IconButton>
                </Tooltip>

              )}

              <Feature name="feature_export_data">
                <XLSXDownloadBtn clipped={cliped} fontColor={fontColor} useNewStyle={true}/>
              </Feature>

              <Tooltip title="Save this section as an image">
                <IconButton aria-label="settings"><ImageIcon style={{color: fontColor}} onClick={download}/></IconButton>
              </Tooltip>
          </ButtonGroup>
          }/>


          <OverviewTabClipsPopout
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          clips={session && session['stimulusclips']}
          session={session}
        />
        <ImmersionModal
          size="sm"
          open={showShareModal}
          title={'Share Results'}
          titleOK={''}
          buttonDisable={true}
          onClose={onToggleShareModal}
          additional={<div className={classes.container}>
            <BackDropAnalyzeLoading loading={loading}/>
            <div className={classes.p1}>
              Share your results with anyone using the following web link. Recipients will not<br />
              need to create an account to access.
            </div>

            {!confirmed &&
              <div>
                <p className={classes.text}>
                  I am aware and intend to share this data publicly and no login will be required to view the <br />
                  shared data. I understand that video playback of the original content measured may be <br />
                  possible. I confirm that I am authorized to share this data and have rights to share this <br />
                  content with the general public.
                </p>
                <Button
                  variant={"contained"}
                  color="primary"
                  onClick={() => {
                    setConfirmed(true);
                    onCallShareAPI();
                  }}
                  className={classes.confirmBtn}
                >
                  Confirm & Continue
                </Button>
              </div>}

              {confirmed && <>
                {(uuid && !loading) && <div style={{ margin: "auto", justifyContent: "center", display: "flex", alignItems: "center", marginTop: 32 }}>

                  <CopyToClipboard
                    text={`${Config.SHARING_URL}/${uuid}`}
                    onCopy={() => { setCopied(true) }}
                  >
                    <Button variant={"contained"} color={copied ? "default" : "primary"} className={classes.copyBtn} disabled={copied}>
                      {copied ? 'Copied' : 'Copy'}
                    </Button>
                  </CopyToClipboard>

                  {`${Config.SHARING_URL}/${uuid}`}

                </div>}
                {(!uuid && !loading) &&
                <div className={classes.p2} style={{ color: 'red' }}>
                  Can not share the UUID for this session.
                </div>}

                <div className={classes.p2}>
                  <b>PLEASE NOTE</b>: Anyone with the above link can access the page.
                </div>
              </>}
          </div>}
        />


<ImmersionModal
        open={showVideoModal}
        title={!loading ? (stimulusList?.length > 0 ? "Change Video" : "Add a Video") : 'Uploading Video...'}
        buttonDisable={next || asyncFile?.size && loading}
        titleOK={'Save'}
        okDisable={finishUploadVideoResult !== '' || linkError}
        loading={loading && (finishUploadVideoResult !== '' || isLink)}
        cancelDisable={true}
        onClose={onCloseAddVideo}
        additional={<div className={classes.videomodelCss}>
          {!finishUploadVideoResult && !loading && (isLink ?
            <>
              <TextField
                InputLabelProps={{
                  classes: {
                    root: classes.videolabel,
                    focused: classes.videofocusedLabel,
                    error: classes.videoerroredLabel
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.videounderline,
                    error: classes.videoerror
                  }
                }}
                style={{ width: '100%' }}
                margin="normal"
                defaultValue={videoUrl}
                id="videoUrl"
                label="Link to video URL"
                name="videoUrl"
                onChange={onChangeVideoUrl}
                helperText={<span className="creator-helperText">
                  <span title={"Upload from your computer"}
                    onClick={() => toggleUploadMethod(false)}>or
                    upload from your computer...</span></span>}
              />
              {linkError && <span className={classes.videolinkError}>
                Unfortunately we have found an issue with your video. <br />Please make sure the video you have used does not infringe upon copyrights or is publically available.
              </span>}
            </>
            : <div style={{ margin: "auto", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <Button variant="contained"
                className={classes.videobrowseBtn}
                onClick={() => triggerInputFile(fileInput)}
              >Browse</Button>
              <input
                type="file"
                id="fileUpload"
                className={classes.videofileInput}
                ref={(fileInput: any) => setFileInput(fileInput)}
                onChange={(e: any) => handleFileInput(e)}
              />
              &nbsp;&nbsp;&nbsp;
              <TextField
                InputLabelProps={{
                  classes: {
                    root: classes.videolabel,
                    focused: classes.videofocusedLabel,
                    error: classes.videoerroredLabel
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.videounderline,
                    error: classes.videoerror
                  }
                }}
                inputProps={{ readOnly: true }}
                style={{ flex: 7 }}
                margin="normal"
                id="localVideoUrl"
                value={asyncFileName}
                label="Upload from your computer"
                name="localVideoUrl"
                helperText={<span className="creator-helperText">
                  <span title={"link from a URL"} onClick={() => toggleUploadMethod(true)}>or
                    link from a URL</span></span>}
              />
            </div>
          )}
          {showSizeAlarm && (
            <span className={classes.videolinkError}>
              For best video playback, we suggest keeping your video under 200 MB. For more information, please consult our&nbsp;
              <a
                className={classes.videoanchor}
                rel="noreferrer"
                href={`${Config.INTERCOM_URL}/articles/6817251-best-practices-for-video-playback`}
                target={'_blank'}
              >
                video playback article
              </a>
            </span>
          )}
          {loading && !isLink && <div className={classes.videoprogress}>
            <LinearProgress variant="determinate" value={uploadVideoProgress} />
            <Box mt={3} mb={10} />
          </div>}
          {!loading && <div className={classes.videosuccessLabel}>
            {finishUploadVideoResult}
            <br /><br />
            {finishUploadVideoResult === 'You uploaded the video successfully.' &&
              <Button
                variant="contained"
                color='primary'
                className={classes.videocalendarBtnLabel}
                onClick={onCloseAddVideo}
              >
                Continue
              </Button>}
          </div>}
        </div>}
        onApply={uploadVideo}
      />





        </>


    )


    };


export default OverviewCardHeader;
